var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLunchDining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "48px",
    viewBox: "0 0 20 20",
    width: "48px",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.99,8c0.26-2.73-3.42-5-7.99-5C5.44,3,1.76,5.27,2.01,8H17.99z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    width: 16,
    x: 2,
    y: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.34,9.25c-1.58,0-1.72,1-2.67,1c-0.95,0-1.08-1-2.67-1c-1.58,0-1.72,1-2.67,1c-0.95,0-1.09-1-2.67-1 c-1.58,0-1.72,1-2.67,1v1.5c1.58,0,1.72-1,2.67-1c0.95,0,1.09,1,2.67,1c1.58,0,1.72-1,2.67-1c0.95,0,1.08,1,2.67,1 c1.58,0,1.72-1,2.67-1c0.95,0,1.08,1,2.66,1v-1.5C17.05,10.25,16.92,9.25,15.34,9.25z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunchDining);
export default __webpack_public_path__ + "static/media/lunch_dining.bf539102205e058b1bf1fa54b8cb438b.svg";
export { ForwardRef as ReactComponent };